module.exports = __webpack_public_path__ + "img/3.7f21c04c.png";